import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../auth/Auth";

function ContactLookup() {
  const { axiosInstance } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleLookup = async () => {
      try {
        const params = new URLSearchParams(location.search);
        const phone = params.get("phone");
        const email = params.get("email");

        if (!phone && !email) return;

        const res = await axiosInstance.get(
          `/contacts/lookup?phone=${phone || ""}&email=${email || ""}`,
        );

        if (res.data.found && res.data.contact) {
          const contactId = res.data.contact.id;

          // redirect to existing page
          navigate(`/contacts/${contactId}`);
        } else {
          //   alert("Unknown caller");
          //   navigate(
          //     `/contacts?create=true&phone=${phone || ""}&email=${email || ""}`,
          //   );
          const queryParams = new URLSearchParams();
          queryParams.append("create", "true");

          if (phone) queryParams.append("phone", phone);
          if (email) queryParams.append("email", email);

          navigate(`/contacts?${queryParams.toString()}`);
        }
      } catch (err) {
        console.error(err);
      }
    };

    handleLookup();
  }, []);

  return <div>Looking up contact...</div>;
}

export default ContactLookup;
